import "./RequestMainInformation.css";
import DateObject from "react-date-object";
import PumperList from "../features/PumperList/PumperList";

function RequestMainInformation({ request }) {
  let date = new DateObject();

  date._format = "DD.MM.YY";
  date = date.parse(request.date);

  date.months = [
    ["jan", "Января"], //[["name","shortName"], ... ]
    ["feb", "Февраля"],
    ["mar", "Марта"],
    ["apr", "Апреля"],
    ["may", "Мая"],
    ["jun", "Июня"],
    ["jul", "Июля"],
    ["aug", "Августа"],
    ["sep", "Сентября"],
    ["oct", "Октября"],
    ["nov", "Ноября"],
    ["dec", "Декабря"],
  ];

  return (
    <div style={{ paddingTop: "10px" }} className="requestInfoContainer">
      <div className="requestInformationList">
        <div className="requestInfoElement">
          <span className="requestInfoTitle">Клиент / Адрес</span>
          <span className="requestInfoValue">
            {request?.counterpart} / {request.address}
          </span>
        </div>
        <div className="requestInfoElement">
          <span className="requestInfoTitle">Дата и время</span>
          <span className="requestInfoValue">
            {date.format("DD MMM YYYY")} {request.time}
          </span>
        </div>
        <div className="requestInfoElement">
          <span className="requestInfoTitle">Номенклатура / Осадка конуса</span>
          <span className="requestInfoValue">
            {request.nomenclature}/ ОК - {request.cone_draft}
          </span>
        </div>
        <div className="requestInfoElement">
          <span className="requestInfoTitle">Объём / Способ отгрузки</span>
          <span className="requestInfoValue">
            {request.capacity} / {request.acceptance_method}
          </span>
        </div>
        {request.acceptance_method === "Насос" && (
          <div className="requestInfoElement">
            <span className="requestInfoTitle">Параметры насоса</span>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <span className="requestInfoValue">
                под заказ: {request.ownPumps}
              </span>
              <span className="requestInfoValue">
                свои: {request.contractorPumps}
              </span>
            </div>
          </div>
        )}
        {request.pumpDescriptions && (
          <div className="requestInfoElement">
            <span className="requestInfoTitle">Насосы под заказ</span>
            <PumperList data={request.pumpDescriptions} />
          </div>
        )}

        <div className="requestInfoElement">
          <span className="requestInfoTitle">Интервал / Интенсивность</span>
          <span className="requestInfoValue">
            {request.interval} / {request.intensity}
          </span>
        </div>
        <div className="requestInfoElement">
          <span className="requestInfoTitle">Принимает на объекте</span>
          <span className="requestInfoValue">{request.phone_number}</span>
        </div>
        <div className="requestInfoElement">
          <span className="requestInfoTitle">Завел заявку</span>
          <span className="requestInfoValue">
            {request.customerPhoneNumber}
          </span>
        </div>
      </div>
    </div>
  );
}

export default RequestMainInformation;
